import axios from 'axios'

import {
  type DateTimeMs,
  type PreviewGrabData,
  type PreviewPageContent,
} from '../types/applicationData.type'

// HOME_COUNTDOWN.dateParam can arrive as an ISO string; the preview wants
// `DateTimeMs`. Typing the axios response with `ServerPreviewGrabData`
// forces every new server-vs-editor divergence to surface through
// `parseServerPageContent` rather than silently flowing through.

type StrictCountdown = Extract<PreviewPageContent, { type: 'HOME_COUNTDOWN' }>

type ServerCountdown = Omit<StrictCountdown, 'dateParam'> & {
  dateParam?: string | DateTimeMs
}

type ServerPageContent =
  | Exclude<PreviewPageContent, { type: 'HOME_COUNTDOWN' }>
  | ServerCountdown

type ServerPreviewGrabData = Omit<
  PreviewGrabData,
  'homeContents' | 'menuContents'
> & {
  homeContents: ServerPageContent[]
  menuContents: ServerPageContent[]
}

function parseServerPageContent(c: ServerPageContent): PreviewPageContent {
  if (c.type === 'HOME_COUNTDOWN') {
    const param = c.dateParam
    const dateParam: DateTimeMs | undefined =
      typeof param === 'string'
        ? (new Date(param).getTime() as DateTimeMs)
        : param
    return { ...c, dateParam }
  }
  return c
}

export const ApplicationDataService = {
  async getCurrent(
    locale: 'fr' | 'en',
    filterOnlyVisible: boolean,
  ): Promise<PreviewGrabData> {
    const { data } = await axios.get<ServerPreviewGrabData>(
      `/api/exports/current?locale=${locale}${filterOnlyVisible ? '&filterOnlyVisible=1' : ''}`,
    )
    return {
      ...data,
      homeContents: data.homeContents.map(parseServerPageContent),
      menuContents: data.menuContents.map(parseServerPageContent),
    }
  },
}
